import React from "react";
import { TextInput } from "@jsq/ds/core";
import { createFieldPlaceholder } from "./utils";
import type { FieldEditorProps } from "./types";

/**
 * Default Field Editor Component
 *
 * Fallback component for unknown or unsupported field types.
 * Provides basic text input functionality with consistent styling.
 */
export const DefaultFieldEditor: React.FC<FieldEditorProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
}) => {
  return (
    <TextInput
      value={value}
      onSetValue={onChange}
      placeholder={createFieldPlaceholder(field)}
      disabled={disabled}
      errorMessage={error || undefined}
      isFullWidth
      data-testid="default-field-editor"
    />
  );
};

export default DefaultFieldEditor;
